import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { combineLatest, Observable, Subject } from 'rxjs';
import { filter, take, takeUntil, withLatestFrom } from 'rxjs/operators';

import {
  AuthStore,
  DELAY_OPTIONS,
  InstallationDetailsStore,
  SrcNotificationSettingsStore,
} from '@store';
@Component({
  selector: 'app-src-settings-connection-status',
  templateUrl: './src-settings-connection-status.component.html',
  styleUrl: './src-settings-connection-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SrcSettingsConnectionStatusComponent implements OnInit, OnDestroy {
  readonly delayOptions = DELAY_OPTIONS;

  readonly isEnabled$: Observable<boolean> = this.srcNotificationSettingsStore.isEnabled$;
  readonly threshold$: Observable<string> = this.srcNotificationSettingsStore.threshold$;
  readonly loading$: Observable<boolean> = this.srcNotificationSettingsStore.loading$;

  private installationId: number;
  private isEnabled: boolean;
  private threshold: string;
  private readonly ngUnsubscribe$ = new Subject<void>();

  constructor(
    protected readonly authStore: AuthStore,
    private readonly installationDetailsStore: InstallationDetailsStore,
    private readonly srcNotificationSettingsStore: SrcNotificationSettingsStore
  ) {}

  ngOnInit(): void {
    // One-time initial load
    this.installationDetailsStore.getInstallationId$
      .pipe(
        filter((id) => !!id),
        take(1),
        withLatestFrom(this.authStore.isRsaUser()),
        filter(([, isRsa]) => !isRsa),
        takeUntil(this.ngUnsubscribe$)
      )
      .subscribe(([installationId]) => {
        this.installationId = installationId;
        this.srcNotificationSettingsStore.get(installationId);
      });

    combineLatest([this.isEnabled$, this.threshold$])
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(([isEnabled, threshold]) => {
        this.isEnabled = isEnabled;
        this.threshold = threshold;
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  onToggleChange(checked: boolean): void {
    this.srcNotificationSettingsStore.set(this.installationId, checked, this.threshold);
  }

  onDelayChange(threshold: string): void {
    this.srcNotificationSettingsStore.set(this.installationId, this.isEnabled, threshold);
  }
}
